import { Box, Skeleton, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useQuery } from '@tanstack/react-query'
import { USER_REFERRAL_INFO } from '../../../../api/endpoints.constants'
import { getUserRefferalInfo } from '../../../../api/userReferral'
import { CoinLabel } from '../../../../components/CoinLabel'
import { theme } from '../../../../theme'
import ReferralProgramStatisticsItem from './ReferralProgramStatisticsItem'

const ReferralProgramStatistics = () => {
    const { data: referralInfo, isLoading } = useQuery({
        queryKey: [USER_REFERRAL_INFO],
        queryFn: () => getUserRefferalInfo(),
    })

    const { bonus_amount, referral_count } = referralInfo || {}

    const statistics = (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                width: '100%',
                [theme.breakpoints.down('md')]: {
                    flexDirection: 'column',
                },
            }}>
            <ReferralProgramStatisticsItem name="Приглашено пользователей" value={referral_count} />
            <ReferralProgramStatisticsItem
                name="Заработано"
                value={<CoinLabel coin={bonus_amount ?? 0} />}
            />
        </Box>
    )

    const skeleton = (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                width: '100%',
                [theme.breakpoints.down('md')]: {
                    flexDirection: 'column',
                },
            }}>
            <Skeleton
                variant="rectangular"
                width="30%"
                height={94}
                sx={{ borderRadius: '16px' }}
                animation="wave"
            />
            <Skeleton
                variant="rectangular"
                width="30%"
                height={94}
                sx={{ borderRadius: '16px' }}
                animation="wave"
            />
            <Skeleton
                variant="rectangular"
                width="30%"
                height={94}
                sx={{ borderRadius: '16px' }}
                animation="wave"
            />
        </Box>
    )

    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}>
            <Typography variant="h5">Статистика по реферальной программе</Typography>
            {isLoading ? skeleton : statistics}
        </Grid>
    )
}

export default ReferralProgramStatistics
